import MenuDataAnalytics from "../MenuDataAnalytics";
import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuInicioRapido from "../MenuInicioRapido";
import React, { useEffect, useState } from "react";
import PesquisaArtigo from "../PesquisaArtigo";

export default function AnaliseGeografica() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollButton && window.pageYOffset > 400) {
        setShowScrollButton(true);
      } else if (showScrollButton && window.pageYOffset <= 400) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScrollButton]);

  useEffect(() => {
    // Rola a página para o topo sempre que a página é carregada
    window.scrollTo(0, 0);
  }, []); // Executa o efeito apenas uma vez, quando o componente é montado

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/data-analytics">Data Analytics</a>
                  </li>
                  <li className="breadcrumb-item active">Análise Geográfica</li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuDataAnalytics />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">Análise Geográfica</h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">Data Analytics</span>
                </div>
                <small className="col-6 text-right pr-5">
                  Conheça seu cliente
                </small>
              </div>
              <hr />

              <div className="content article-content">
                <br></br>

                <p>
                  <h3>O que é Análise Geográfica?</h3>
                </p>

                <p>
                  A análise geográfica no contexto de Data Analytics desempenha
                  um papel crucial na compreensão e interpretação de dados
                  relacionados à localização geográfica.
                </p>

                <p>
                  Esse tipo de análise permite a visualização e compreensão de
                  padrões espaciais nos dados. Por exemplo, ao mapear a
                  distribuição de lojas de varejo em uma cidade e sobrepor{" "}
                  <a> </a>
                  <a href="\como-conhecer-meu-cliente" target="blank">
                    dados demográficos
                  </a>
                  , é possível identificar áreas com potencial de mercado,
                  compreender o comportamento do consumidor e otimizar
                  estratégias de expansão de negócios.
                </p>

                <p>
                  Ao importar sua base de clientes na <a> </a>{" "}
                  <a href="https://salesbox.com.br/identity/" target="blank ">
                    Plataforma Sales Box
                  </a>
                  , apresentamos na guia "MAPA" um mapa de calor onde você pode
                  visualizar a distribuição geográfica de seus clientes, e na
                  guia "GRÁFICO" apresentamos a distribuição deles por cidade.
                </p>

                <figure id="market-share">
                  <a
                    href={`/imagepage?image=${encodeURIComponent(
                      "img/analise-geografica.png"
                    )}`}
                    target="_blank"
                  >
                    <img
                      src="img/analise-geografica.png"
                      alt="excel"
                      style={{ display: "block", margin: "0 auto" }}
                    />
                  </a>
                </figure>

                <figcaption>Análise geográfica: Mapa de calor</figcaption>

                <figure id="market-share">
                  <a
                    href={`/imagepage?image=${encodeURIComponent(
                      "img/analise-geografica-cidade.png"
                    )}`}
                    target="_blank"
                  >
                    <img
                      src="img/analise-geografica-cidade.png"
                      alt="excel"
                      style={{ display: "block", margin: "0 auto" }}
                    />
                  </a>
                </figure>

                <figcaption>
                  Análise geográfica: Distribuição por cidade
                </figcaption>

                <p>
                  <h3>
                    A Importância da Análise Geográfica na Avaliação de Crédito
                  </h3>
                </p>

                <p>
                  Compreender a geografia de um cliente não se trata apenas de
                  saber onde ele mora, mas de entender como o ambiente ao seu
                  redor pode influenciar sua capacidade financeira e
                  comportamento de pagamento. Essa análise proporciona insights
                  valiosos que podem otimizar a tomada de decisões e a gestão de
                  riscos associados ao crédito.
                </p>

                <p>
                  Diferentes regiões possuem características socioeconômicas
                  distintas que podem afetar diretamente o risco associado a
                  operações de crédito. Áreas com histórico de alta
                  inadimplência ou instabilidades econômicas representam um
                  risco maior para credores. Por exemplo, regiões que enfrentam
                  altas taxas de desemprego ou reduzida atividade econômica
                  podem ter uma incidência maior de inadimplência em comparação
                  com áreas mais estáveis e prósperas.
                </p>

                <p>
                  Ao integrar a análise geográfica no processo de avaliação de
                  crédito, as instituições financeiras podem ajustar as
                  condições de crédito para corresponder ao perfil de risco da
                  área. Isso pode incluir ajustar taxas de juros, definir
                  limites de crédito mais cautelosos ou modificar os termos de
                  pagamento.
                </p>

                <p>
                  <h3>Implicações Positivas da Análise Geográfica</h3>
                </p>

                <ul>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Personalização de Ofertas:
                    </a>{" "}
                    A análise geográfica permite que os serviços e produtos
                    sejam personalizados para atender às necessidades
                    específicas dos clientes em diferentes regiões, melhorando a
                    satisfação do cliente e a eficácia do serviço.
                  </li>
                  <li>
                    <a style={{ fontWeight: "bold" }}>
                      Desenvolvimento de Mercado:
                    </a>{" "}
                    Compreender as dinâmicas geográficas também pode revelar
                    oportunidades de mercado em regiões subatendidas, e por sua
                    vez, criar novas oportunidades de negócios.
                  </li>
                </ul>

                <p>
                  Em resumo, ter uma compreensão geográfica da sua base é
                  fundamental para a extração de insights valiosos que
                  impulsionam ainda mais a tomada de decisões.
                </p>

                <br></br>
              </div>

              {/* Seção de votos */}

              <div>
                <PesquisaArtigo />
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuInicioRapido />
            </div>
          </div>
        </div>
      </section>

      {showScrollButton && (
        <a onClick={scrollToTop} className="btn-topo">
          <a style={{ fontSize: "25px" }}>↑</a> Voltar ao Topo
        </a>
      )}

      <Footer />
    </>
  );
}
